<template>
  <form class="form">
    <div class="mb-3">
      <label
        for="username"
        class="form-label"
        :class="nameIsCorrect ? 'has_required' : ''"
      >
        {{ $store.state.language.username }}
      </label>
      <input
        type="text"
        class="form-control"
        id="username"
        maxlength="20"
        aria-describedby="username"
        v-model="username"
      />
      <div class="form-text">{{ $store.state.language.hintUsername }}</div>
    </div>
    <div class="mb-3">
      <label
        for="email"
        class="form-label"
        :class="emailIsCorrect ? 'has_required' : ''"
      >
        {{ $store.state.language.emailAddress }}
      </label>
      <input
        type="email"
        maxlength="33"
        class="form-control"
        id="email"
        v-model="email"
      />
      <div id="emailHelp" class="form-text">
        {{ $store.state.language.hintMail }}
      </div>
    </div>
    <div class="mb-3">
      <label
        for="password"
        class="form-label"
        :class="has_minimum_lenth ? 'has_required' : ''"
      >
        {{ $store.state.language.password }}</label
      >
      <span class="btn" @click="$store.state.utils.switTypeInput">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          />
        </svg>
      </span>
      <input
        type="password"
        class="form-control"
        id="password"
        maxlength="50"
        v-model="password"
      />
    </div>
    <div class="mb-3">
      <label
        for="repeatPassword"
        class="form-label"
        :class="
          password === repeatPassword && password.length > 7
            ? 'has_required'
            : ''
        "
      >
        {{ $store.state.language.repeatPassword }}</label
      >
      <input
        type="password"
        class="form-control"
        id="repeatPassword"
        maxlength="50"
        v-model="repeatPassword"
      />
    </div>
    <div class="form-group mb-3">
      <ul id="passwordHelp" class="form-text text-muted">
        <li :class="has_lowercsae ? 'has_required' : ''">
          {{ $store.state.language.oneLowercaseLetter }}
        </li>
        <li :class="has_uppercase ? 'has_required' : ''">
          {{ $store.state.language.oneUppercaseLetter }}
        </li>
        <li :class="has_number ? 'has_required' : ''">
          {{ $store.state.language.oneNumber }}
        </li>
        <li :class="has_special ? 'has_required' : ''">
          {{ $store.state.language.oneSpecialCharacter }}
        </li>
        <li :class="has_minimum_lenth ? 'has_required' : ''">
          {{ $store.state.language.atLeast8Characters }}
        </li>
      </ul>
    </div>

    <div class="text-end mt-5">
      <button
        v-if="password.length > 3 && username.length > 3 && email.length > 3"
        type="submit"
        class="btn btn-main-dark"
        @click="singUp"
      >
        {{ $store.state.language.register }}
      </button>
      <button v-else type="submit" class="btn btn-main-dark disabled" disabled>
        {{ $store.state.language.register }}
      </button>
    </div>
    <hr />
    <div class="mt-2">
      <router-link :to="{ name: 'Signin' }" custom v-slot="{ navigate }">
        <span
          role="link"
          @click="navigate"
          class="btn"
          @keypress.enter="navigate"
        >
          {{ $store.state.language.iHaveAccount }}
        </span>
      </router-link>
    </div>
  </form>
</template>

<script>
export default {
  name: "SignUp",

  data() {
    return {
      password: "",
      repeatPassword: "",
      username: "",
      email: "",

      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,

      passwordIsCorrect: false,
      nameIsCorrect: false,
      emailIsCorrect: false,
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },

  watch: {
    password() {
      const val = this.$store.state.utils.filters.password(this.password);

      this.has_minimum_lenth = val.has_minimum_lenth;
      this.has_number = val.has_number;
      this.has_lowercsae = val.has_lowercsae;
      this.has_uppercase = val.has_uppercase;
      this.has_special = val.has_special;

      this.passwordIsCorrect =
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth;
    },

    username() {
      this.username = this.username.toLowerCase();
      const val = this.$store.state.utils.filters.username(this.username);

      this.nameIsCorrect =
        val.has_minimum_lenth && val.only_letters && val.is_mail;
    },

    email() {
      const val = this.$store.state.utils.filters.validateEmail(this.email);

      this.emailIsCorrect = val;
    },
  },

  methods: {
    singUp() {
      event.preventDefault();

      if (this.username.length < 3 && this.username.length > 20) {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: this.$store.state.language.usernameError,
          },
          3000
        );
        return;
      }
      if (this.email.length < 12 && this.email.length > 33) {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: this.$store.state.language.emailError,
          },
          3000
        );
        return;
      }

      if (
        this.passwordIsCorrect &&
        this.password === this.repeatPassword &&
        this.nameIsCorrect &&
        this.emailIsCorrect
      ) {
        this.$store.state.utils.processing = true;
        const data = {
          username: this.username,
          email: this.email,
          password: this.password,
        };

        this.$store.state.modules.api
          .singUp(data)
          .then((resp) => {
            if (resp.status == 200) {
              this.username = "";
              this.email = "";
              this.password = "";
              this.repeatPassword = "";
              this.$store.state.modules.account.user = resp.data.user;
              this.$store.state.modules.account.token = resp.data.token;

              this.$router.push({ name: "LandingPage" });
              setTimeout(() => {
                location.reload();
              }, 100);
            } else {
              this.$store.state.utils.setNewNotifications(
                {
                  type: "warning",
                  message: this.$store.state.language.registerError,
                },
                2500
              );
            }
            this.$store.state.utils.processing = false;
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: this.$store.state.language.registerInputsError,
          },
          3000
        );
        this.$store.state.utils.processing = false;
      }
    },
  },
};
</script>
